import { Upload } from "lucide-react";

/**
 * Full-cover overlay shown while files are dragged over a Kai chat surface.
 * Purely presentational; the parent controls when it renders based on the
 * `isDragging` flag from `useKaiFileDrop`. The parent must be positioned
 * (relative) so this absolute overlay covers it.
 */
export function KaiFileDropOverlay() {
  return (
    <div
      aria-hidden="true"
      className="glass-overlay pointer-events-none absolute inset-2 z-30 flex items-center justify-center rounded-2xl border border-dashed border-primary/50"
    >
      <div className="flex flex-col items-center gap-2 text-center">
        <div className="flex size-11 items-center justify-center rounded-xl bg-primary/15 text-primary">
          <Upload className="size-5" />
        </div>
        <p className="text-sm font-medium text-foreground">
          Drop files to attach
        </p>
        <p className="text-xs text-muted-foreground">PDF, Excel, CSV, or images</p>
      </div>
    </div>
  );
}
